import { IHttpAdapter } from '../../core/entities/iHttpAdapter';
import { API_IDS } from '@intigral/constant/endpoint/ApiIdMapper';
import { IZendeskRepository } from '../../core/repositories/interfaces/iZendeskRepository';
import IZendeskForm from '../../core/entities/iZendeskForm';

import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IApiPathManager } from '../config/ApiPathManager';

export default class ZendeskRepository implements IZendeskRepository {
    private static instace: ZendeskRepository;

    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async submitForm(payload: IZendeskForm, credentials: string) {
        const path = this.apiPathManager.getPath(API_IDS.ZENDESK_SUBMIT_FORM);
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Basic ${credentials}`,
        };
        const config = {
            body: payload,
            headers,
        };
        const res = await this.http.post<unknown>(path, config);
        return res.status === 201;
    }
}
